<template>
<v-main>
    <div v-if="issomethingloading && !variety.length">
    <v-container>
        <v-row  >
            <v-col cols="12" class="text-center">
                <v-progress-circular
                        :size="100"
                        :width="7"
                        color="primary"
                        indeterminate
                ></v-progress-circular>
            </v-col>
        </v-row>
    </v-container>
    </div>
        <div v-else>
<v-container fluid>
  <head>
  <title>{{variety.name}} - Foraje</title>
    <meta name="description" :content="variety.short_description">

  </head>
    <!--Should probably move to main page/app, so it looks better-->
    <v-alert dismissible color="success" icon="mdi-check-circle" v-model="varietyimagesubmittedalert">Image Submitted! Thanks! If it looks good, it should be approved soon! You can go ahead and submit more if you like.</v-alert>
    <v-alert dismissible color="success" icon="mdi-check-circle" v-model="quickcreatesuccessalert">Crop successfully created! You can go to your crops or your profile to see it.</v-alert>

  <v-row  >
    <v-col class="pa-4" cols="12" sm="6" >
      <v-card text class="transparent" >
      <v-carousel :cycle="false" v-if="varietyimages && varietyimages.length">
        <v-carousel-item v-for="(item,i) in varietyimages"
                         :key="i" :src="item.image.full_size" :lazy-src="item.image.thumbnail">
        </v-carousel-item>
      </v-carousel>
          <v-img v-else
                 aspect-ratio="1"
                 src="https://nyc3.digitaloceanspaces.com/foraje-static-1/media/static/images/misc/unknownchile.svg">
          </v-img>
        <v-dialog v-model="varietyimagedialog"
                  v-if="this.userIsAuthenticated"
                  max-width="500">
          <template v-slot:activator="{ on }">
      <v-btn
              dark
              absolute
              fab
              bottom
              right
              color="primary"
              v-on="on"
      >
        <v-icon>mdi-camera-plus</v-icon>
      </v-btn>
          </template>
          <v-card>
            <form @submit.prevent="SubmitVarietyImage">

            <v-card-title
                    class="headline grey lighten-2"
                    primary-title
            >
              Submit a new {{variety.name}} Image
            </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-file-input
                      :label="'Image of ' + variety.name"
                      hint="'A picture of this variety that you would like to upload"
                      prepend-icon="mdi-camera"
                      v-model="selectedFile"
                      accept="image/*"
                      required
                    >
                      <template v-slot:selection="{ text }">
                        <v-chip
                          small
                          label
                          color="primary"
                        >
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
                <v-btn
                        color="secondary"
                        type="submit"
                        class="layout justify-center"
                        :loading="imagesubmitloading"
                        :disabled="imagesubmitloading"
                >
                  Submit
                  <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                </v-btn>
              </v-card-actions>
            </form>
          </v-card>

        </v-dialog>
        <v-dialog v-model="varietyimagelogindialog"
                  v-if="!this.userIsAuthenticated"
                  max-width="500">
          <template v-slot:activator="{ on }">
          <v-btn
                  dark
                  absolute
                  fab
                  bottom
                  right
                  color="primary"
                  v-on="on"
          >
            <v-icon>mdi-camera-plus</v-icon>
          </v-btn>
          </template>
          <v-card>

              <v-card-title
                      class="headline grey lighten-2"
                      primary-title
              >
                Submit a new {{variety.name}} Image
              </v-card-title>

              <v-card-text>
                <h4>Please log in or sign up!</h4>
                <p>Sorry, you must be logged in to submit new pictures. Please create an account, or login to continue</p>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn
                        v-if="!userIsAuthenticated"
                        text
                        router-link
                        v-bind:to="'/sign_up'"
                >
                  Sign Up
                </v-btn>
                <v-btn
                        v-if="!userIsAuthenticated"
                        text
                        router-link
                        v-bind:to="'/sign_in'"
                >
                  Sign In
                </v-btn>
              </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-col>
  <v-col class="BasicInfo pa-4" cols="12" sm="6" >
    <v-card>

      <v-col class="ma-4" >
          <v-row>
          <v-col cols="9">
        <h1>{{variety.name}}<v-btn v-if="variety.wikipedia_url !== null" v-bind:href="variety.wikipedia_url" text icon outlined large color="light-green darken-4">
          <v-icon>mdi-wikipedia</v-icon>
        </v-btn></h1>

        <router-link v-if="variety.species" v-bind:to="'/guide/species/' + variety.species.slug"><h4><em>{{variety.species.name}}</em></h4></router-link>
          </v-col>
              <!--gaaaaah it's not pixel aligned with the edit quicklook one, but whatever works for now, infuriating as it may be-->
          </v-row>


          <!--<v-divider v-if="this.userIsAuthenticated"></v-divider>
              <div class="text-center">
                  <v-btn v-if="this.userIsAuthenticated" @click="setSelectedVariety">
                      <span class="hidden-sm-and-up" style="font-size: x-small">Add to My Crops</span>
                        <span class="hidden-xs-only">Add to My Crops</span>
                  </v-btn>
              </div>

          &lt;!&ndash;This is a hacky solution to stop the button's text from overflowing the card/div, obviously not ideal or truly responsive, would rather have the button go multiline or something Or just think of a shorter way to phrase it&ndash;&gt;
              <div class="text-center">
                  <v-btn v-if="this.userIsAuthenticated" @click="CropQuickCreate">
                      <span class="hidden-sm-and-up" style="font-size: x-small">One-Click Add to my Crops</span>
                      <span class="hidden-xs-only">One-Click Add to my Crops</span>
                  </v-btn>
              </div>-->
        <v-divider></v-divider>
        <v-row class="QuickLook"  >
          <v-col class="ma-2 mt-4" cols="9" >
            <span class="headline">Quick Look</span>
          </v-col>
            <v-col cols="12">
<ul class="bigFont">
    <li v-if="variety.alternate_names">Also known as: {{variety.alternate_names}}</li>
    <li v-if= "variety.variety_group">In the <router-link :to="'/guide/variety_group/' + variety.variety_group.slug">'{{variety.variety_group.name}}'</router-link> Group</li>
  <li>{{variety.short_description}}</li>
  <li v-if="variety.short_extra_information">{{variety.short_extra_information}}</li>
  <li><b>Fertility:</b> {{variety.fertility}}</li>
  <li><b>Time to Maturity:</b> {{variety.maturity_time}}</li>
</ul>
              <div  v-if="varietycomponents && varietycomponents.length">
            <ul class="bigFont" v-for="varietycomponent of varietycomponents" :key="varietycomponent.id">
    <li v-if="varietycomponent.name === 'Fruit'">
      <b>Fruit Color:</b> {{varietycomponent.colors}}
    </li>
    <li  v-if="varietycomponent.name === 'Flowers'">
      <b>Flower Color:</b> {{varietycomponent.colors}}
    </li>
                <!--TODO go through and replace all the extra h2s and whatnot with classes for specific sizing-->
            </ul>
              </div>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
</v-col>
  </v-row>
</v-container>
  <v-divider></v-divider>
  <v-divider></v-divider>
  <v-tabs light fixed-tabs icons-and-text centered slider-color="yellow" show-arrows>
      <v-tab key="general_info">
        General Info
        <v-icon>mdi-information-outline</v-icon>
      </v-tab>
      <v-tab key="culinary">
        Culinary Info
        <v-icon>mdi-food-fork-drink</v-icon>

      </v-tab> <br>
      <v-tab key="growing_info">
        Growing Info
        <v-icon>mdi-sprout</v-icon>

      </v-tab>
    <v-tab key="historical_info">
      Historical Info
      <v-icon>mdi-pillar</v-icon>

    </v-tab>
    <!--<v-tab href="#environmental_info">-->
      <!--Environmental Info-->
    <!--<v-icon>nature</v-icon>-->
    <!--</v-tab>-->
    <v-tab key="storage_info">
      Transport and Storage Info
      <v-icon>mdi-truck-fast</v-icon>
    </v-tab>
    <v-tab key="danger_info">
      Risks/Dangers
      <v-icon>mdi-alert</v-icon>
    </v-tab>
    <!--<v-tab key="growers" @click="FirstClickFetchProducers">
      People Growing This
      <v-icon>mdi-nature-people</v-icon>
    </v-tab>
    <v-tab href="#products" @click="TabClickFetchProducts(varietycomponents[0].id)">
      Products
      <v-icon>mdi-package-variant-closed</v-icon>
    </v-tab>-->
    <v-tab-item key='general_info'>
      <v-container >

      <v-row class="Description"  >

        <v-col cols="12">
        <v-card hover raised >
        <v-card-title primary-title>
            <h3>Description</h3>
        </v-card-title>
          <v-card-text>
            <p v-if="variety.description && variety.description.length">{{ variety.description }}</p>
            <p v-else-if="variety.short_description && variety.short_description.length">{{variety.short_description}}</p>
            <p v-else>Sorry, we don't seem to have a good description of this variety yet. Contact us if you'd like to submit one!</p>
          </v-card-text>
        </v-card>
        </v-col>

        <v-col cols="12">
        <v-card hover raised>
          <v-card-title primary-title>
              <h3>Special Treatment, if any:</h3>
          </v-card-title>
          <v-card-text>
              <p v-if="variety.special_treatment">{{variety.special_treatment}}</p>
              <p v-else>Requires no special treatment (standard things like days of frost for fruit set, or anything unusual, that doesn't fit anywhere else) as far as we're aware. </p>
          </v-card-text>
        </v-card>
        </v-col>

        <v-col cols="12">
          <v-card hover raised>
            <v-card-title primary-title>
                 <h3>Physical Description</h3>
            </v-card-title>
        <v-card-text>
            <v-tabs v-if="varietycomponents && varietycomponents.length" light centered slider-color="yellow" icons-and-text v-model="description_tab">
                <v-tab v-for="varietycomponent of varietycomponents" :key="varietycomponent.id">
                    {{varietycomponent.name}}
                    <!--<v-icon>{{varietycomponent.preferred_icon}}</v-icon>-->
                </v-tab>

            <v-tabs-items v-model="description_tab">
                <v-tab-item v-for="varietycomponent of varietycomponents" :key="varietycomponent.id">
                    <v-container>
                        <v-row  >
                            <v-col cols="12">
                                <v-card hover raised>
                            <v-card-title primary-title>
                                <h3>Colors:</h3>
                            </v-card-title>
                            <v-card-text>
                                <p>{{varietycomponent.colors}}</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                            <v-col cols="12">
                                <v-card hover raised>
                                    <v-card-title primary-title>
                                        <h3>Dimensions:</h3>
                                    </v-card-title>
                                    <v-card-text>
                                        <p>{{varietycomponent.dimensions}}</p>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
            </v-tabs-items>
            </v-tabs>

            <div v-else>
                <span>
                    Sorry! We don't know anything about the aesthetics of this variety, ie colors of leaves, shape of fruit, etc.
                </span>
            </div>
        </v-card-text>
          </v-card>
        </v-col>

        <!-- TODO, figure out a display, maybe a card, for parent varieties, manytomany outputs the pk, and we route through slugs. figure it out-->

        <v-col cols="12">
          <v-card hover raised>
            <v-card-title primary-title>
                <h3>Genealogy</h3>
            </v-card-title>
            <v-card-text v-if="variety.parent_stock">
        <span v-if="variety.parent_stock[0]">Parents:<li v-for="parent of variety.parent_stock" :key="parent.id"><router-link v-bind:to="'/guide/variety/' + parent.slug" ><em>{{parent.name}} </em></router-link></li></span>
        <span v-else>Sorry, we're not sure what the parent varieties are. </span>
            </v-card-text>
          </v-card>
        </v-col>


        <v-col cols="12" v-if="variety.extra_information && variety.extra_information.length">
          <v-card hover>
            <v-card-title primary-title>
        <h3>Extra Information</h3>
            </v-card-title>
            <v-card-text>
            {{variety.extra_information}}
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>
      </v-container>
    </v-tab-item>


    <v-tab-item key='culinary'>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-tabs v-if="varietycomponents && varietycomponents.length" light centered slider-color="yellow" icons-and-text v-model="culinary_tab">
            <v-tab v-for="varietycomponent of varietycomponents" :key="varietycomponent.id">
                {{varietycomponent.name}}
                <!--<v-icon>{{varietycomponent.preferred_icon}}</v-icon>-->
            </v-tab>

            <v-tabs-items v-model="culinary_tab">
                <v-tab-item v-for="varietycomponent of varietycomponents" :key="varietycomponent.id">
                    <v-container >
                        <v-row  >
                        <v-col cols="12">
                            <v-card hover raised>
                                <v-card-title primary-title>
                                    <h3>Culinary Uses:</h3>
                                </v-card-title>

                                <v-card-text>

                                    <p>{{varietycomponent.culinary_uses}}</p>
                                </v-card-text>
                            </v-card>
                        </v-col>

                                <v-col cols="12">
                                    <v-card hover raised>
                                        <v-card-title primary-title>
                                            <h3>Flavor:</h3>
                                        </v-card-title>
                                        <v-card-text>
                                    <p>{{varietycomponent.flavor_description}}</p>
                                        </v-card-text>
                                    </v-card>
                                </v-col>


                                            <v-col cols="12">

                                                <v-card hover raised>
                                                    <v-card-title primary-title>
                                                        <h3>Average Nutrition:</h3>
                                                    </v-card-title>
                                                    <v-card-text>
                                    <p>{{varietycomponent.average_nutrition}}</p>
                                    </v-card-text>
                            </v-card>
                        </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>

        <v-container  v-if="varietycomponents.length === 0">
            <v-row  >
          <v-col cols="12">
            <v-card hover raised>
                <!--TODO add propose new component button, or link at least-->
                <v-card-text>
                <h4>Our Bad, Send Help</h4>
                <span>We don't know enough about this variety's culinary information to say anything in particular here.
                    Heck we don't even know if this variety has fruit, seeds, and leaves, or fur and meat!
                    You can change that though! If you know something we don't, please send us more info! Like telling us
                what kind of bits this variety has!</span>
              </v-card-text>
            </v-card>
          </v-col>
            </v-row>
        </v-container>

    </v-tab-item>

    <v-tab-item key='growing_info'>
      <v-container >
      <v-row class="GrowingInfo"  >

        <v-col cols="12">
          <v-card hover raised>
            <v-card-title primary-title>
              <h3>General Biology</h3>
            </v-card-title>

            <v-card-text>
          <div>
              <h4>Maturity Time:</h4>{{variety.maturity_time}}
          </div>

          <h4>Growth Characteristics</h4>
          <span>{{variety.growth_characteristics}}</span>

          <h4>Lifecycle Info</h4>
          <span>{{variety.lifecycle_information}}</span>

            </v-card-text>
          </v-card>


          <v-col cols="12">
            <v-card hover raised>
              <v-card-title primary-title>
          <h3>Environmental Conditions</h3>
              </v-card-title>
              <v-card-text>
          <h5>pH Range</h5>
          <span>{{variety.ph_range}}</span>
          <h5>Preferred pH</h5>
          <span>{{variety.preferred_ph}}</span>
          <h4>Preferred Temperatures</h4>
          <span>{{variety.temperature_info}}</span>
          <h4>Growing Media</h4>
          <span>{{variety.growing_media}}</span>
          <h4>Light Exposure</h4>
          <span>{{variety.light_preferences}}</span>
          <h4>Elevation Preferences</h4>
          <span>{{variety.elevation_preferences}}</span>
          <h4>Wind Preferences</h4>
          <span>{{variety.wind_preferences}}</span>
          <h4>Hydration Requirements</h4>
          <span>{{variety.hydration_preferences}}</span>
          <h4>Space Requirements</h4>
          <span>{{variety.spacing_information}}</span>
          <h4>Nutrient Information</h4>
          <span>{{variety.nutrient_information}}</span>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card xs12 s6 m4 ma-2 hover raised>
              <v-card-title primary-title>
          <h3>Reproduction/Genetics</h3>
              </v-card-title>
              <v-card-text>
          <h4>Ploidy:</h4>
          <span>{{variety.ploidy}}</span>
          <h4>Fertility: </h4>
          <span>{{variety.fertility}}</span>
          <h4>Propagation Information</h4>
          <span>{{variety.propagation_information}}</span>
          <!--Genetic modifications, if so, and what modifications were made, with detail-->
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card xs12 s6 m4 ma-2 hover raised>
              <v-card-title primary-title>
          <h3>Vulnerabilities and resistances</h3>
              </v-card-title>
              <v-card-text>
          <h4>Predator Information</h4>
          <span>{{variety.predator_information}}</span>
          <h4>Disease/Pest Vulnerabilities</h4>
          <span>{{variety.vulnerability_information}}</span>
          <h4>Disease/Pest Resistances</h4>
          <span>{{variety.resistance_information}}</span>
              </v-card-text>
            </v-card>
          </v-col>

        </v-col>
      </v-row>
      </v-container>
    </v-tab-item>


    <v-tab-item key='historical_info'>
      <v-container >
      <v-row  >

          <v-col cols="12">

          <v-card xs12 s6 m4 ma-2 hover>
            <v-card-title primary-title><h3>Origin Story</h3>
            </v-card-title>
            <v-card-text>{{variety.variety_history}}</v-card-text>
          </v-card>
            </v-col>

          <v-col cols="12">
          <v-card xs12 s6 m4 ma-2 hover>
            <v-card-title primary-title>
      <h3>When this variety originated:</h3>
            </v-card-title>
          <v-card-text>{{variety.origin_date}}</v-card-text>
          </v-card>
          </v-col>


          <v-col cols="12" md="6" v-if="variety.location_coordinates">

          <v-card ma-2 hover>
            <v-card-title primary-title><h3>Where this variety came from:</h3>
            </v-card-title>
          <v-card-text>
              <v-col>
              {{variety.origin_location}}
              <v-btn @click="GetMapReady" color="primary" text>
                  <v-icon>mdi-map-marker</v-icon>
              </v-btn>
              </v-col>
          </v-card-text>
          </v-card>
          </v-col>

              <v-col v-if="showmap && variety.location_coordinates" cols="12" md="6" class="map" v-touch="{
        left: () => dontPropagate(),
        right: () => dontPropagate()
        }">
                  <l-map ref="map" :zoom="zoom" :center="center" :world-copy-jump="true">
                      <l-tile-layer :url="'https://api.tiles.mapbox.com/v4/mapbox.streets/{z}/{x}/{y}.png?access_token=' + accessToken" :attribution="attribution"></l-tile-layer>
                      <l-marker :lat-lng="marker"></l-marker>
                  </l-map>
              </v-col>

          <v-col v-if="!variety.location_coordinates" cols="12">
              <v-card ma-2 hover>
              <v-card-title primary-title><h3>Where this variety came from:</h3>
              </v-card-title>
              <v-card-text>
                  <v-col>
                      {{variety.origin_location}}
                  </v-col>
              </v-card-text>
              </v-card>
          </v-col>

          <v-col cols="12">
          <v-card xs12 s6 m4 ma-2 hover>
          <v-card-title primary-title><h3>Who's responsible for this variety?</h3>

          </v-card-title>

            <v-card-text>
                <div v-if="variety.breeder">
            <h4>Original Breeder:</h4>
          <!--TODO, think about how to edit this thing, maybe a different form for now, where users can suggest who the initial breeder was, kinda more like a contact form? Could be the same form actually, but then replace the field value with just a note, and we can do the lookup-->
                <span v-if="variety.breeder[0]"><li v-for="breeder of variety.breeder" :key="breeder.id"><router-link :to="'/profiles/' + breeder.slug">{{breeder.display_name}}</router-link></li></span>
      <span v-else> We're not sure who the original breeder of the variety was, it may have been lost to the sands of time, or it might be a wild derived variety. More likely, the breeder isn't on Foraje yet, so we can't link to their profile. If you know them, please have them sign up!</span>
                </div>
                <div v-if="variety.seed_saver">
                    <h4>Seed Saver:</h4>
                <span v-if="variety.seed_saver[0]"><li v-for="seedsaver of variety.seed_saver" :key="seedsaver.id"><router-link :to="'/profiles/' + seedsaver.slug">{{seedsaver.display_name}}</router-link></li></span>
          <span v-else> We're not sure who saved this variety for us all to enjoy, or they're not on Foraje yet. Invite them!</span>
                </div>
            </v-card-text>
          </v-card>
          </v-col>
      </v-row>

      </v-container>
    </v-tab-item>
    <v-tab-item key='storage_info'>
        <v-divider></v-divider>
        <v-divider></v-divider>
                <v-tabs v-if="varietycomponents && varietycomponents.length" light centered slider-color="yellow" icons-and-text v-model="storage_tab">
                    <v-tab v-for="varietycomponent of varietycomponents" :key="varietycomponent.id">
                        {{varietycomponent.name}}
                        <!--<v-icon>{{varietycomponent.preferred_icon}}</v-icon>-->
                    </v-tab>

                    <v-tabs-items v-model="storage_tab">
                    <v-tab-item v-for="varietycomponent of varietycomponents" :key="varietycomponent.id">
                        <v-container >
                            <v-row  >
                                <v-col cols="12">
                                    <v-card hover raised>
                                        <v-card-title primary-title>
                                            <h3>Harvest:</h3>
                                        </v-card-title>
                                        <v-card-text>
                                            {{varietycomponent.harvest_information}}
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12">
                                    <v-card hover raised>
                                        <v-card-title primary-title>
                                            <h3>Storage:</h3>
                                        </v-card-title>
                                        <v-card-text>
                                            {{varietycomponent.storage_information}}
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12">
                                    <v-card hover raised>
                                        <v-card-title primary-title>
                                            <h3>Transportation:</h3>
                                        </v-card-title>
                                        <v-card-text>
                                            {{varietycomponent.transportation_information}}
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-tab-item>
                    </v-tabs-items>
                </v-tabs>
        <v-container  v-if="varietycomponents.length === 0">
            <v-row  >
        <v-col cols="12">
            <v-card hover raised>
                <!--TODO add propose new component button-->
                      <v-card-text>
                          <h4>Our Bad, Send Help</h4>
                          <span>We don't know enough about how this variety (or any of its component parts, like fruit, seeds, etc.)
                              ought to be handled when it comes to harvest, transportation or storage. to say anything in particular here.
                              Heck we don't even know if this variety has fruit, seeds, and leaves, or fur and meat!
                    You can change that though! If you know something we don't, please send us more info! Like telling us
                what kind of bits this variety has!</span>
                      </v-card-text>
                  </v-card>
              </v-col>
            </v-row>
        </v-container>

    </v-tab-item>
    <v-tab-item key='danger_info'>
        <v-container >
            <v-row  >

                <v-col cols="12">

                    <v-card xs12 s6 m4 ma-2 hover>
                        <v-card-title primary-title><h3>Known Allergens</h3>
                        </v-card-title>
                        <v-card-text>{{variety.allergen_information}}</v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <v-card xs12 s6 m4 ma-2 hover>
                        <v-card-title primary-title>
                            <h3>Toxicity</h3>
                        </v-card-title>
                        <v-card-text>{{variety.toxicity_information}}</v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <v-card xs12 s6 m4 ma-2 hover>
                        <v-card-title primary-title><h3>Other Concerns</h3>
                        </v-card-title>

                        <v-card-text>{{variety.other_dangers}}</v-card-text>
                    </v-card>
                </v-col>
            </v-row>

        </v-container>
    </v-tab-item>


      <v-tab-item key='growers'>
          <v-divider></v-divider>
          <v-divider></v-divider>
                      <v-container >
                          <v-row   v-if="areproducersloading && !producers.length">
                              <v-col cols="12" class="text-center">
                                  <v-progress-circular
                                          :size="100"
                                          :width="7"
                                          color="primary"
                                          indeterminate
                                  ></v-progress-circular>
                              </v-col>
                          </v-row>

                          <v-row   v-if="producers && producers.length" class="hidden-sm-and-up">
                              <v-col class="ma-1" cols="12" v-for="producer of producers" :key="producer.slug">
                                  <v-card>
                                      <v-row>
                                          <v-col class="pa-3 ml-3" v-if="producer.profile_image && producer.profile_image.thumbnail" cols="5" >
                                              <v-img
                                                      :src="producer.profile_image.thumbnail"
                                                      class="fill-height"
                                              ></v-img>
                                          </v-col>
                                          <v-col v-else cols="5">
                                              <v-img
                                                      src="https://nyc3.digitaloceanspaces.com/foraje-static-1/media/static/images/misc/unknownchile.svg"
                                                      contain
                                              ></v-img>
                                          </v-col>
                                          <v-col cols="7" class="pt-1">
                                              <div>
                                                  <div style="font-size: large">
                                                      <router-link :to="'/profiles/' + producer.slug">
                                                          {{producer.display_name}}
                                                      </router-link>
                                                  </div>
                                              </div>
                                          </v-col>
                                      </v-row>
                                      <v-divider></v-divider>
                                  </v-card>
                              </v-col>
                          </v-row>
                          <v-row   v-if="producers && producers.length" class="hidden-xs-only">
                              <v-col class="ma-1" sm="3" v-for="producer of producers" :key="producer.slug">
                                  <v-card>
                                      <v-row>
                                          <v-col class="pa-3 ml-3" v-if="producer.profile_image && producer.profile_image.thumbnail" cols="5" >
                                              <v-img
                                                      :src="producer.profile_image.thumbnail"
                                                      class="FetchedThumbail"
                                                      aspect-ratio="1"
                                              ></v-img>
                                          </v-col >
                                          <v-col v-else cols="5">
                                              <v-img
                                                      src="https://nyc3.digitaloceanspaces.com/foraje-static-1/media/static/images/misc/unknownchile.svg"
                                                      contain
                                              ></v-img>
                                          </v-col>
                                          <v-col cols="7" class="pt-1">
                                              <v-card-title primary-title>
                                                  <div>
                                                      <div style="font-size: medium">
                                                          <router-link :to="'/profiles/' + producer.slug">
                                                              {{producer.display_name}}
                                                          </router-link>
                                                      </div>
                                                      <v-divider></v-divider>
                                                  </div>
                                              </v-card-title>
                                          </v-col>
                                      </v-row>
                                      <v-divider></v-divider>
                                  </v-card>

                              </v-col>
                          </v-row>
                          <v-row   v-else-if="!areproducersloading && !producers.length">
                              <v-col cols="12">

                                  <v-card xs12 s6 m4 ma-2 hover>
                                      <v-card-title primary-title><h3>Nobody we know of!</h3></v-card-title>
                                      <v-card-text>
                                          <p>
                                              Nobody on the entire earth is growing this particular variety. If we're wrong about that, and you
                                              are in fact growing ' {{variety.name}} ' please let us know!
                                          </p>
                                          <p v-if="!this.userIsAuthenticated">Just sign in, and then click 'Add to my Crops' or 'One click Add to my Crops'
                                          </p>
                                      </v-card-text>
                                  </v-card>
                              </v-col>
                          </v-row>

                          <v-row   v-if="producers && producers.length">
                          <v-col cols="12" class="text-center">
                              <v-btn
                                      v-if="this.producerspageCount > 1"
                                      @click="ProducersLoadPreviousBatch"
                                      :loading="areproducersloading"
                                      class="secondary"
                              >
                                  Previous Producers
                                  <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
                              </v-btn>
                              <v-btn
                                      v-if="this.producersfullresponse.next !== null"
                                      @click="ProducersLoadNextBatch"
                                      :loading="areproducersloading"
                                      class="primary"
                              >

                                  More Producers
                                  <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
                              </v-btn>
                          </v-col>
                          </v-row>
                      </v-container>
      </v-tab-item>

      <v-tab-item value='products'>
          <v-divider></v-divider>
          <v-divider></v-divider>
          <v-tabs v-if="varietycomponents && varietycomponents.length" light centered slider-color="yellow" icons-and-text v-model="product_tab">
              <v-tab v-for="varietycomponent of varietycomponents" :key="varietycomponent.id" @click.native="TabClickFetchProducts(varietycomponent.id)">
                  {{varietycomponent.name}}
                  <!--<v-icon>{{varietycomponent.preferred_icon}}</v-icon>-->
              </v-tab>

              <v-tabs-items v-model="product_tab">
                  <v-tab-item v-for="varietycomponent of varietycomponents" :key="varietycomponent.id" class="ProductAndCropTabs">
          <v-container >
              <v-row   v-if="areproductsloading && !products.length">
                  <v-col cols="12" class="text-center">
                      <v-progress-circular
                              :size="100"
                              :width="7"
                              color="primary"
                              indeterminate
                      ></v-progress-circular>
                  </v-col>
              </v-row>

              <v-row   v-if="products && products.length" class="hidden-sm-and-up">
                  <v-col class="ma-1" cols="12" v-for="product of products" :key="product.id">
                      <v-card>
                          <v-row>
                              <v-col class="pa-3 ml-3" v-if="product.product_image && product.product_image.length > 0" cols="5" >
                                  <v-img
                                          :src="product.product_image[0].image.thumbnail"
                                          class="FetchedThumbail"
                                          aspect-ratio="1"
                                  ></v-img>
                              </v-col >
                              <v-col v-else cols="5">
                                  <v-img
                                          src="https://nyc3.digitaloceanspaces.com/foraje-static-1/media/static/images/misc/unknownchile.svg"
                                          contain
                                  ></v-img>
                              </v-col>
                              <v-col cols="7" class="pt-1">
                                  <v-card-title primary-title>
                                      <div style="font-size: medium">
                                          <router-link :to="'/crops/' + product.parent_product.slug + '/products/' + product.slug">
                                              {{product.display_name}}
                                          </router-link>
                                      </div>

                                  </v-card-title>
                              </v-col>
                          </v-row>
                          <v-divider></v-divider>
                          <v-card-actions class="pa-3">
                              <v-row  >
                                  <v-col style="font-size: medium" cols="8">${{product.price.slice(0, -2)}} per {{product.price_units}}</v-col>
                                  <v-col v-if="product.external_page" cols="3">
                                      <a :href="product.external_page">
                                          Buy it Here!
                                      </a>
                                  </v-col>
                                  <v-col v-else cols="3">
                                          <span>
                                                    Not sure where you can buy it, sorry.
                                                  </span>
                                  </v-col>

                                  <v-col cols="12" v-if="product.similar_products && product.similar_products.length">
                                      Other Options:
                                  </v-col>

                                  <v-col v-if="product.similar_products && product.similar_products.length"
                                          v-for="similarproduct in product.similar_products"
                                         :key="similarproduct.id"
                                          style="font-size: medium">

                                      <router-link
                                              :to="'/crops/' + similarproduct.crop_slug + '/products/' + similarproduct.slug">
                                          ${{similarproduct.price.slice(0, -2)}} per {{similarproduct.price_units}}
                                      </router-link>

                                  </v-col>

                              </v-row>
                          </v-card-actions>

                      </v-card>

                  </v-col>
              </v-row>
                              <v-row   v-if="products && products.length" class="hidden-xs-only">
                                  <v-col class="ma-1" sm="3" v-for="product of products" :key="product.id">
                                          <v-card>
                                              <v-row>
                                                  <v-col class="pa-3 ml-3" v-if="product.product_image && product.product_image.length > 0" cols="5" >
                                                      <v-img
                                                              :src="product.product_image[0].image.thumbnail"
                                                              class="FetchedThumbail"
                                                              aspect-ratio="1"
                                                      ></v-img>
                                                  </v-col >
                                                  <v-col v-else cols="5">
                                                      <v-img
                                                              src="https://nyc3.digitaloceanspaces.com/foraje-static-1/media/static/images/misc/unknownchile.svg"
                                                              contain
                                                      ></v-img>
                                                  </v-col>
                                                      <v-col cols="7" class="pt-1">
                                                          <v-card-title primary-title>
                                                              <div style="font-size: medium">
                                                                  <router-link :to="'/crops/' + product.parent_product.slug + '/products/' + product.slug">
                                                                  {{product.display_name}}
                                                                  </router-link>
                                                              </div>

                                                          </v-card-title>
                                                      </v-col>
                                              </v-row>
                              <v-divider></v-divider>
                              <v-card-actions class="pa-3">
                                  <v-row  >
                                  <v-col style="font-size: medium" cols="8">${{product.price.slice(0, -2)}} per {{product.price_units}}</v-col>
                                  <v-col v-if="product.external_page" cols="3">
                                      <a :href="product.external_page">
                                      Buy it Here!
                                  </a>
                                  </v-col>
                                      <v-col v-else cols="3">
                                          <span>
                                                    Not sure where you can buy it, sorry.
                                                  </span>
                                      </v-col>

                                      <v-col cols="12" v-if="product.similar_products && product.similar_products.length">
                                          Other Options:
                                      </v-col>

                                      <v-col v-if="product.similar_products && product.similar_products.length"
                                              v-for="similarproduct in product.similar_products"
                                             :key="similarproduct.id"
                                              style="font-size: medium">

                                          <router-link
                                                  :to="'/crops/' + similarproduct.crop_slug + '/products/' + similarproduct.slug">
                                              ${{similarproduct.price.slice(0, -2)}} per {{similarproduct.price_units}}
                                          </router-link>

                                      </v-col>

                                  </v-row>
                              </v-card-actions>

                      </v-card>

                  </v-col>
              </v-row>
              <v-row   v-else-if="!areproductsloading && !products.length">
                  <v-col cols="12">

                      <v-card xs12 s6 m4 ma-2 hover>
                          <v-card-title primary-title><h3>Nobody we know of!</h3></v-card-title>
                          <v-card-text>
                              <p>
                                  Nobody on the entire earth is selling these!. If we're wrong about that, and you
                                  are in fact selling {{varietycomponent.variety.name}} {{varietycomponent.name}} <router-link :to="'/forms/products/create'">please let us know!</router-link>
                              </p>
                          </v-card-text>
                      </v-card>
                  </v-col>
              </v-row>
              <v-row   v-if="products && products.length">
                  <v-col cols="12" class="text-center">
                      <v-btn
                              v-if="productspageCount > 1"
                              @click="ProductsLoadPreviousBatch(varietycomponent.id)"
                              :loading="areproductsloading"
                              class="secondary"
                      >
                          Previous Products
                          <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
                      </v-btn>
                      <v-btn
                              v-if="productsfullresponse.next !== null"
                              @click="ProductsLoadNextBatch(varietycomponent.id)"
                              :loading="areproductsloading"
                              class="primary"
                      >

                          More Products
                          <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
                      </v-btn>
                  </v-col>
              </v-row>


          </v-container>
                  </v-tab-item>
              </v-tabs-items>
          </v-tabs>
      </v-tab-item>
  </v-tabs>

    </div>
</v-main>
</template>

<script>
import axios from 'axios';

import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';

export default {
  data: () => ({
    variety: [],
    errors: [],
    dialog: false,
    varietyimages: [],
    varietycomponents: [],
    varietycomponent: '',

    products: [],
    areproductsloading: false,
    productspageCount: 1,
    productsfullresponse: [],

    crops: [],
    arecropsloading: false,
    cropspageCount: 1,
    cropsfullresponse: [],

    producers: [],
    areproducersloading: false,
    producerspageCount: 1,
    producersfullresponse: [],

    varietyimagedialog: false,
    varietyimagelogindialog: false,
    selectedFile: null,
    varietyimagesubmittedalert: false,
    imagesubmitloading: false,
    quickcreatesuccessalert: false,
    nestedtabs: false,
    issomethingloading: false,

    // mappy-bits
    center: null,
    marker: null,
    zoom: 6.5,
    accessToken: process.env.VUE_APP_MAPBOX_API_KEY,
    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    map: null,
    showmap: false,
    description_tab: null,
    storage_tab: null,
    product_tab: null,
    culinary_tab: null,

  }),

  components: { LMap, LTileLayer, LMarker },

  // Fetches variety info when the component is created.
  created() {
    this.fetchData();
    // SUPER HACKY I KNOW
  },
  // calls fetchData when url changes
  watch: {
    '$route.params.slug': function () {
      this.fetchData();
    },
  },
  computed: {
    userIsAuthenticated() {
      return this.$store.getters.token;
    },
    // Okay it works, but obviously not super elegant, but it seems to be okay.
    listOfParentVarieties() {
      let computedparents = ' ';
      if (this.variety.parent_stock && this.variety.parent_stock.length) {
        // eslint-disable-next-line no-restricted-syntax,no-undef
        for (progenitor of this.variety.parent_stock) {
          // eslint-disable-next-line no-restricted-syntax,no-undef
          computedparents += `${progenitor.name}, `;
        }
        computedparents = computedparents.replace(/,\s*$/, '');
      } else { computedparents = 'Sorry, we\'re not sure what the parent varieties are.'; }

      return computedparents;
    },
  },
  methods: {
    fetchData() {
      this.issomethingloading = true;
      const varietySlug = this.$route.params.slug;
      axios.get(`/varieties/${varietySlug}/`)
        .then((response) => {
          this.variety = response.data;
          if (response.data.location_coordinates) {
            // eslint-disable-next-line no-undef
            this.center = L.GeoJSON.coordsToLatLng(response.data.location_coordinates.coordinates);
            // eslint-disable-next-line no-undef
            this.marker = L.GeoJSON.coordsToLatLng(response.data.location_coordinates.coordinates);
          }

          return axios.get(`/image/by/variety/${this.variety.id}/`);
        })
        .then((response) => {
          this.varietyimages = response.data;
          return axios.get(`filtered/component/by/variety/${this.variety.id}/`);
        })
        .then((response) => {
          this.varietycomponents = response.data;
          this.issomethingloading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setSelectedVariety() {
      this.$store.dispatch('setSelectedVariety', { variety: this.variety.id, species: this.variety.species })
        .then(this.$router.push('/forms/crops/create/'));
    },
    SubmitVarietyImage() {
      const formData = new FormData();
      this.imagesubmitloading = true;
      formData.append('image', this.selectedFile, this.selectedFile.name);
      formData.append('variety', this.variety.id);
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.post('image/variety/create/', formData,
        {
          headers: {
            Authorization: authheader,
          },
        })
        .then(() => {
          this.varietyimagesubmittedalert = true;
        })
        .then(() => {
          this.varietyimagedialog = false;
        })
        .then(() => {
          this.imagesubmitloading = false;
          this.selectedFile = null;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    removeEmptyStrings(obj) {
      const newObj = {};
      Object.keys(obj).forEach((prop) => {
        if (obj[prop] !== '') { newObj[prop] = obj[prop]; }
      });
      return newObj;
    },
    // TODO roll this into the quickcreate so it's DRY
    GetSavedDefaults() {
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.get('profile/saveddefaults/',
        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.defaultshippinglocation = response.data.default_shipping_location;
          this.defaultgrowinglocation = response.data.default_growing_location;
          this.defaultgrowinginformation = response.data.default_growing_information;
        })
        .catch(
          (error) => {
            console.log(error.response);
          },
        );
    },
    CropQuickCreate() {
      const authheader = `Token ${this.$store.getters.token}`;
      if (this.userIsAuthenticated) {
        return axios.get('profile/saveddefaults/',
          {
            headers: {
              Authorization: authheader,
            },
          })
          .then(response => axios.post('baseproduct/create/', {
            variety: this.variety.id,
            producer: this.$store.state.user.pk,
            growing_location: response.data.default_growing_location,
            growing_information: response.data.default_growing_information,
          },
          {
            headers: {
              Authorization: authheader,
            },
          }))
          .then(() => {
            if (!this.$store.getters.error) {
              console.log('success!');
            }
          })
          .then(() => {
            if (!this.$store.getters.error) {
              this.quickcreatesuccessalert = true;
            }
          })
          .catch((error) => {
            console.log("Error quick adding item to 'stead");
            console.log(error);
          });
      }
    },
    FetchProductsByVariety() {
      this.areproductsloading = true;
      const varietyId = this.variety.id;
      axios.get(`/filtered/products/by/variety/${varietyId}`)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.products = response.data;
        })
        .then(() => {
          this.areproductsloading = false;
        });
    },
    FetchProductsByComponent(componentid) {
      this.areproductsloading = true;
      axios.get(`/filtered/products/by/component/${componentid}/?page=${this.productspageCount}`)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.products = response.data.results;
          this.productsfullresponse = response.data;
        })
        .then(() => {
          this.areproductsloading = false;
        });
    },
    ProductsLoadNextBatch(componentid) {
      if (this.productsfullresponse.next != null) {
        this.productspageCount += 1;
        this.FetchProductsByComponent(componentid);
      }
    },

    ProductsLoadPreviousBatch(componentid) {
      this.productspageCount -= 1;
      this.FetchProductsByComponent(componentid);
    },
    TabClickFetchProducts(componentid) {
      this.productspageCount = 1;
      this.FetchProductsByComponent(componentid);
    },


    FetchCropsByVariety() {
      this.arecropsloading = true;
      const varietyId = this.variety.id;
      axios.get(`/filtered/baseproduct/by/variety/${varietyId}/?page=${this.cropspageCount}`)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.crops = response.data.results;
          this.cropsfullresponse = response.data;
        })
        .then(() => {
          this.arecropsloading = false;
        });
    },
    CropsLoadNextBatch() {
      if (this.cropsfullresponse.next != null) {
        this.cropspageCount += 1;
        this.FetchCropsByVariety();
      }
    },

    CropsLoadPreviousBatch() {
      this.cropspageCount -= 1;
      this.FetchCropsByVariety();
    },
    FirstClickFetchCrops() {
      if (!this.crops.length) {
        this.FetchCropsByVariety();
      }
    },

    FetchProducersByVariety() {
      this.areproducersloading = true;
      const varietyId = this.variety.id;
      axios.get(`filtered/user/by/baseproduct/variety/${varietyId}/?page=${this.producerspageCount}`)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.producers = response.data.results;
          this.producersfullresponse = response.data;
        })
        .then(() => {
          this.areproducersloading = false;
        });
    },
    ProducersLoadNextBatch() {
      if (this.producersfullresponse.next != null) {
        this.producerspageCount += 1;
        this.FetchProducersByVariety();
      }
    },

    ProducersLoadPreviousBatch() {
      this.producerspageCount -= 1;
      this.FetchProducersByVariety();
    },
    FirstClickFetchProducers() {
      if (!this.producers.length) {
        this.FetchProducersByVariety();
      }
    },

    // MAP STUFF!

    // hacky solution to get leaflet map to render right.
    GetMapReady() {
      setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 5);
      this.showmap = !this.showmap;
    },
    dontPropagate() {
      // eslint-disable-next-line no-restricted-globals
      event.stopPropagation();
    },
  },


  mounted() {
    // Make leaflet callable
    if (this.variety.length) {
      this.$nextTick(() => {
        this.map = this.$refs.map.mapObject; // work as expected
      });
    }
  },

};
</script>

<style scoped>
  .BasicInfo{
    display:inline-flex;
    vertical-align: top;
  }
  .Photo{
    vertical-align: top;
    display: flex;
    object-fit: contain;

  }
  .QuickLook{
    display:flex;
    max-width: 400px;
  }
  .Vendors{
    display: flex;
    vertical-align: top;
    max-width: 500px;

  }
  .Description{
    display: flex;
    vertical-align:top;
  }
  .bigFont li{
    font-size:16px;
  }
  .tabCardTitle{
  }
  .tabCardContent{

  }
  .NestedTabs{
      outline: 5px solid #00796B;

  }

  >>> .v-jumbotron__image{
    max-width: 500px;
    max-height: 500px;
    object-fit: cover;
  }
  >>>.v-carousel__next > .v-btn{
      background: rgba(0,0,0,.5)
  }
  >>>.v-carousel__prev > .v-btn{
      background: rgba(0,0,0,.5)
  }

  .FetchedThumbail{
      border-radius: 50%;
  }

  .map{
      height: 400px;
      margin: 0;
  }

    .ProductAndCropTabs{
        min-height: 400px;
    }


</style>
